var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentAltIcon = function SvgCommentAltIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M11.5 6.875V2.5c0-.957-.793-1.75-1.75-1.75H1.875C.891.75.125 1.543.125 2.5v4.375c0 .984.766 1.75 1.75 1.75v1.504c0 .219.246.328.41.191l2.27-1.695H9.75c.957 0 1.75-.766 1.75-1.75m2.625-1.75h-1.75v1.75c0 1.45-1.203 2.625-2.625 2.625H5.375v1.75c0 .984.766 1.75 1.75 1.75h3.418l2.27 1.723c.164.109.437 0 .437-.22V13h.875c.957 0 1.75-.766 1.75-1.75V6.875c0-.957-.793-1.75-1.75-1.75"
  })));
};
export default SvgCommentAltIcon;